export const isValidUsername = (username) => {
  // 1. Check length
  if (username.length < 4 || username.length > 15) {
    return false;
  }
  // 2. Check allowed characters (regex)
  const pattern = /^[a-zA-Z0-9_]+$/;
  if (!pattern.test(username)) {
    return false;
  }
  // 3. Additional checks (e.g., first character must be a letter)
  if (!/^[a-zA-Z]/.test(username)) {
    return false;
  }
  // 4. Ensure username ends with a letter or digit
  if (!/[a-zA-Z0-9]$/.test(username)) {
    return false;
  }
  // 5. Ensure no consecutive underscores
  if (/__/.test(username)) {
    return false;
  }
  return true;
};
